<script lang="ts" setup>
  import { ref, shallowRef, useSlots, watchEffect } from 'vue';
  import {
    builtInIcon,
    type builtInIconType,
    darkenColor,
    getElementColor,
    textButtonEmits,
    textButtonProps,
  } from './text-button';

  defineOptions({
    name: 'ITextButton',
  });
  const props = defineProps(textButtonProps);
  const emits = defineEmits(textButtonEmits);
  const slots = useSlots();
  const textButtonRef = shallowRef();

  const textButtonIcon = ref('');
  let cacheTextButtonColor = '';
  const textButtonColor = ref('');

  watchEffect(() => {
    if (props.icon) {
      const builtInIconKeys = Object.keys(builtInIcon);
      if (builtInIconKeys.includes(props.icon)) {
        textButtonIcon.value = builtInIcon[props.icon as builtInIconType].icon;
        textButtonColor.value =
          props.textColor || builtInIcon[props.icon as builtInIconType].color || 'var(--el-color-primary)';
      } else {
        textButtonIcon.value = props.icon;
        textButtonColor.value = props.textColor || 'var(--el-color-primary)';
      }
    } else {
      textButtonIcon.value = '';
      textButtonColor.value = props.textColor || 'var(--el-color-primary)';
    }
  });

  const handleMousedown = () => {
    cacheTextButtonColor = textButtonColor.value;
    textButtonColor.value = darkenColor(getElementColor(textButtonRef.value), 0.2);
  };

  const handleMouseup = () => {
    textButtonColor.value = cacheTextButtonColor || 'var(--el-color-primary)';
  };

  const handleClick = (evt: MouseEvent) => {
    if (!props.disabled) emits('click', evt);
  };
</script>

<template>
  <div
    ref="textButtonRef"
    class="i-text-button"
    :class="{
      'i-text-button__disabled': disabled,
    }"
    :style="{ color: textButtonColor }"
    @mousedown="handleMousedown"
    @mouseup="handleMouseup"
    @click="handleClick"
  >
    <!--  图标  -->
    <div v-if="textButtonIcon || slots.icon" class="i-text-button__icon">
      <slot v-if="slots.icon" name="icon" />
      <i v-else class="iconfont" :class="[textButtonIcon]" />
    </div>
    <!--  文本  -->
    <div class="i-text-button__label">
      <slot name="default" />
    </div>
    <!--  下划线  -->
    <span class="i-text-button__line" :style="{ backgroundColor: textButtonColor }" />
  </div>
</template>
